<template>
  <el-drawer
      :visible.sync="showDrawer"
      direction="ltr"
      size="73%"
      @close="handleClose"
    >
      <template slot="title">
        <div class="detail-part-one">
          <div v-if="!nameEditing" class="name-cell">
            <span>{{ publicResourceInfo.name }}</span>
            <i class="iconfont icon-wenjian-bianji ft-theme mg-lt-md edit-icon" @click="toEditName" />
          </div>
          <edit-input
            v-else
            ref="editName"
            class="edit-name-cell"
            :maxlength="30"
            :init-value="publicResourceInfo.name"
            @edit-confirm="modifyName"
            @edit-cancel="nameEditing = false"
          />
        </div>
      </template>
      <div id="ComponentDetail" class="component-detail">
        <div class="detail-part-two" v-if="currentResource.versionId">
          <public-component-info :resource-type="resourceType" />
        </div>
        <div class="detail-part-three">
          <div class="version-row">
            <version-bar
              class="detail-version-bar"
              :current-version="currentResource.softwareVersion"
              :versions="publicResourceVersions"
              @currentChange="versionChange"
            />
            <div class="version-record">
              <el-button plain @click="showDataVersionRecord">版本记录</el-button>
            </div>
          </div>
          <template v-if="currentResource.platformCode">
            <div class="error-tip" v-if="versionResourceInfo.status === 'PROCESSED_FAILED'">
              <i class="el-icon-error"></i>
              <div class="error-content">
                <span>资源解析失败，暂无相关信息，请删除后重新上传</span>
              </div>
            </div>
            <version-component-info v-if="versionResourceInfo.status === 'TOBE_RELEASED'" :resource-type="resourceType" />
            <file-info :resource-type="resourceType" :details="details" @toLoad="$emit('toLoad', details)" />
          </template>
        </div>
        <!-- 数据版本记录 -->
        <data-version-record
            ref="dataVersionRecordDrawer"
            direction="ltr"
            :current-submodule="currentSubmodule"
            :resource-type="resourceType"
            @version-changed="versionChangedForPlugin"
            @toLoad="$emit('toLoad', details)"
        />
    </div>
  </el-drawer>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
// import DictSwitch from '@/core/dictSwitch'
import PublicComponentInfo from '../components/PublicComponentInfo.vue'
import VersionComponentInfo from '../components/VersionComponentInfo.vue'
import DataVersionRecord from '../components/DataVersionRecord.vue'
import VersionBar from '@/components/business/resource/VersionBar.vue'
import FileInfo from '@/views/resource/components/FileInfo.vue'
import EditInput from '@/components/business/EditInput.vue'
import { getResourceType } from '@/assets/js/resourceMap.js'
export default {
  name: 'SchemeDetailPlugin',
  props: {
    currentSubmodule: {
      type: String,
    },
  },
  components: { PublicComponentInfo, VersionBar, VersionComponentInfo, DataVersionRecord, FileInfo, EditInput },
  data() {
    return {
      resourceType: 'SCHEME',
      nameEditing: false,
      showDataDrawer: false,
      versionList: [],
      details: {},
      spaceId: null,
      showDrawer: false,
      isChangedVersion: false
    }
  },
  computed: {
    ...mapGetters({
      currentResource: 'resourceDetail/currentResource',
      publicResourceInfo: 'resourceDetail/publicResourceInfo',
      publicResourceVersions: 'resourceDetail/publicResourceVersions',
      versionResourceInfo: 'resourceDetail/versionResourceInfo',
    }),
  },
  mounted() {
  },
  methods: {
    ...mapMutations({
      setInitCurrentResource: 'resourceDetail/setInitCurrentResource',
      setCurrentResource: 'resourceDetail/setCurrentResource',
    }),
    ...mapActions({
      getSpacePlatClassify: 'classifySpace/getSpacePlatClassify',
      loadPublicResourceInfo: 'resourceDetail/loadPublicResourceInfo',
      loadVersionResourceInfo: 'resourceDetail/loadVersionResourceInfo',
      loadVersionResourceFileInfo: 'resourceDetail/loadVersionResourceFileInfo',
      loadVersionResourceDataVersionInfo: 'resourceDetail/loadVersionResourceDataVersionInfo',
    }),
    async openDrawer(spaceId, item) {
      this.spaceId = spaceId
      this.details = item
      this.setInitCurrentResource({
        spaceId: spaceId,
        spaceResourceId: item.spaceResourceId,
        softwareCode: item.softwareCode,
        softwareVersion: item.softwareVersion,
      })
      await this.initDetail()
      this.$tracks({
        event: 'visitSpaceSchemeDetail',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: this.currentResource.spaceResourceId,
        }
      })
      this.showDrawer = true
    },
    async initDetail() {
      this.$fullLoading.open()
      await this.loadPublicResourceInfo({ space_id: this.spaceId, space_resource_id: this.currentResource.spaceResourceId })
      // 如果没有传版本，则从接口中取第一个版本及版本资源id
      const newestVersionObj = this.publicResourceVersions[0] || {}
      if (newestVersionObj && newestVersionObj.id) {
        await this.getSpacePlatClassify({ space_id: this.spaceId, resource_type: this.resourceType, platform_code: this.currentResource.platformCode })
        this.setCurrentResource({
          versionId: newestVersionObj.id,
          softwareVersion: newestVersionObj.softwareVersion,
        })
        await this.initVersionDetail()
        await this.initVersionList()
      }
      this.$fullLoading.close()
    },
    initVersionDetail() {
      return new Promise((resolve, reject) => {
        const payload = {
          space_id: this.spaceId,
          space_resource_id: this.currentResource.spaceResourceId,
          resource_software_version_id: this.currentResource.versionId,
        }
        this.loadVersionResourceInfo(payload).then(() => { resolve() }, () => { resolve({}) })
        this.loadVersionResourceFileInfo(payload)
      })
    },
    initVersionList() {
      this.versionList = this.publicResourceInfo.softwareVersions
    },
    versionChange(versionObj) {
      const query = this.$route.query
      this.$router.replace({
        name,
        query: {
          ...query,
          versionResourceId: versionObj.id,
          softwareVersion: versionObj.softwareVersion,
        }
      })
    },
    // fmtStatus(value) {
    //   return DictSwitch.switchStatus(value)
    // },
    toEditName() {
      this.nameEditing = true
      // this.$nextTick(() => {
      //   // this.$refs.editName.toFocus()
      // })
    },
    modifyName(value) {
      this.$api.resource.updateName(this.currentResource.spaceId, this.currentResource.spaceResourceId, { name: value }).then(() => {
        this.$message.success(`修改成功`)
        this.nameEditing = false
        this.initDetail()
      }).catch((err) => {
        const errors = {
          'resource.not.exist': '资源不存在',
          'resource.name.contain.special.characters': '名称中有禁止的特殊符号',
          'resource.name.already.existed': '资源名称已存在',
          'name.length.exceed': '资源名称查出限制',
        }
        this.$matchError(err.code, errors, '修改失败')
      })
    },
    modifyStatus(value) {
      const params = {
        resourceSoftwareVersionId: this.currentResource.versionId,
        status: value
      }
      this.$api.resource.common.updateStatus(params).then(() => {
        this.$message.success('状态修改成功')
        this.initVersionDetail()
      }).catch(() => {
        this.$message.error('状态修改失败')
      })
    },
    resourceCn() {
      return getResourceType(this.resourceType)
    },
    showDataVersionRecord() {
      this.loadVersionResourceDataVersionInfo({
        space_id: this.spaceId,
        space_resource_id: this.currentResource.spaceResourceId,
        resource_software_version_id: this.currentResource.versionId,
      })
      this.$refs.dataVersionRecordDrawer && this.$refs.dataVersionRecordDrawer.openDrawer()
    },
    async versionChangedForPlugin(item) {
      this.isChangedVersion = true
      this.$tracks({
        event: 'commissionSpaceSchemeVersion',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: this.currentResource.spaceResourceId,
        }
      })
      await this.initDetail()
    },
    toPlace(row) {
      this.$refs.pluginPlaceTypeDialog && this.$refs.pluginPlaceTypeDialog.openDialog(this.spaceId, row)
    },
    handleClose() {
      if (this.isChangedVersion) {
        this.$emit('close')
      }
    }
  },
}
</script>

<style lang="less" scoped>
.component-detail{
  width: 95%;
  margin: 0 auto;
  padding: 0 16px;
}
.detail-part-one{
  // padding-top: 20px;
  // padding-bottom: 8px;
  // border-bottom: 1px solid @border-color;
  // margin-bottom: 15px;
  .name-cell{
    height: 32px;
    font-size: 18px;
    color: #3D3D3D;
  }
  .edit-icon{
    cursor: pointer;
  }
  .edit-name-cell{
    width: 300px;
  }
}
.detail-part-two{
  border-bottom: 1px solid @border-color;
  padding-top: 15px;
  margin-bottom: 15px;
}
.detail-part-three{
  padding-bottom: 15px;
  .version-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    .version-record {
      justify-content: right;
    }
  }
}
.error-tip {
  width: 100%;
  padding: 8px 16px;
  margin: 0;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  opacity: 1;
  display: flex;
  align-items: center;
  transition: opacity .2s;
  background-color: #ffeded;
  color: #ff4d4f;
  i {
    font-size: 16px;
    width: 16px;
  }
  .error-content {
    display: inline-flex;
    padding: 0 8px;
    width: 100%;
    justify-content: center;
    color: #000000;
  }
}
</style>
